document.addEventListener("DOMContentLoaded", function () {
  if (!window.moqEntries) return;

  const productTypeSelect = document.getElementById("product_type_select");
  const materialSelect = document.getElementById("material_select");
  const resultDiv = document.getElementById("moqResult");
  const linkDiv = document.getElementById("productLinkContainer");

  // 构建 moqData
  const moqData = {};
  window.moqEntries.forEach(entry => {
    if (!moqData[entry.type]) moqData[entry.type] = {};
    moqData[entry.type][entry.material] = {
      MOQ: entry.moq,
      Link: entry.link,
      Title: entry.title
    };
  });

  // Helper: populate select while keeping placeholder
  function populateSelect(selectEl, options, placeholder) {
    selectEl.innerHTML = ''; // 先清空
    if (placeholder) {
      const placeholderOption = document.createElement('option');
      placeholderOption.value = '';
      placeholderOption.textContent = placeholder;
      selectEl.appendChild(placeholderOption);
    }
    options.forEach(opt => {
      // 防重复
      if (!Array.from(selectEl.options).some(o => o.value === opt)) {
        const optionEl = document.createElement("option");
        optionEl.value = opt;
        optionEl.textContent = opt;
        selectEl.appendChild(optionEl);
      }
    });
  }

  // 指定排序顺序
  const preferredOrder = [
    "Mailers - fully customised",
    "Mailers - Partly customised",
    "Bubble Mailers",
    "Envelopes",
    "Poly Garment Bags",
    "Carry Bags",
    "Hygiene Liners"
  ];

  // 初始化 Product Type
  const productTypes = Object.keys(moqData);
  const sortedTypes = productTypes.sort((a, b) => {
    const indexA = preferredOrder.indexOf(a);
    const indexB = preferredOrder.indexOf(b);
    return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
  });
  populateSelect(productTypeSelect, sortedTypes, "-- Select Product Type --");

  // 初始化 Material 只显示 placeholder
  populateSelect(materialSelect, [], "-- Select Material --");

  // Product Type → Material
  productTypeSelect.addEventListener("change", function () {
    resultDiv.textContent = "";
    linkDiv.innerHTML = "";

    const selectedType = productTypeSelect.value;
    if (!selectedType) {
      populateSelect(materialSelect, [], "-- Select Material --");
      return;
    }
    const materials = Object.keys(moqData[selectedType]);
    populateSelect(materialSelect, materials, "-- Select Material --");
  });

  // Material → 显示 MOQ
  materialSelect.addEventListener("change", function () {
    const type = productTypeSelect.value;
    const material = materialSelect.value;
    const entry = moqData?.[type]?.[material];

    if (entry) {
      resultDiv.innerHTML = `
        Thank you! The Minimum Order Quantity for your selection is:<br>
        ${entry.MOQ.toLocaleString()} units
      `;
      linkDiv.innerHTML = `
        <a href="${entry.Link}" target="_blank" class="button button--primary">${entry.Title}</a>
      `;
    } else {
      resultDiv.textContent = "";
      linkDiv.innerHTML = "";
    }
  });
});
